import inputPrice from "@/directives/input_price";
import inputNumber from "@/directives/input_number";

export default (app)=>{
    inputPrice(app);
    inputNumber(app)
}
